import { HomePageContent } from '@epicuro-next/data/merchandise';
import {
  DynamicItemsConfigEntry,
  DynamicItemsConfigWithArguments,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { selectConfigurationValueFrom } from '@epicuro-next/platform/configuration';
import { createSelector } from '@ngrx/store';

import {
  FEATURE_NAME,
  HomeConfigurationKeys,
  HomeConfigurations,
} from '../../configurations';

export const selectFilterBasedLandingPage = selectConfigurationValueFrom<
  HomeConfigurationKeys.FilterBasedLandingPage,
  HomeConfigurations
>(FEATURE_NAME, HomeConfigurationKeys.FilterBasedLandingPage, '');

export const selectFilterBasedHomeDecider = selectConfigurationValueFrom<
  HomeConfigurationKeys.FilterBasedHomeDecider,
  HomeConfigurations
>(FEATURE_NAME, HomeConfigurationKeys.FilterBasedHomeDecider, '');

export const selectMobileComponentUrl = selectConfigurationValueFrom<
  HomeConfigurationKeys.MobileHomePage,
  HomeConfigurations
>(FEATURE_NAME, HomeConfigurationKeys.MobileHomePage, '' as HomePageContent);

export const selectFilterBasedBannerRule = selectConfigurationValueFrom<
  HomeConfigurationKeys.FilterBasedBanner,
  HomeConfigurations
>(FEATURE_NAME, HomeConfigurationKeys.FilterBasedBanner, '');

export const selectMerchandisingDynamicPanelConfigs = createSelector(
  selectConfigurationValueFrom<
    HomeConfigurationKeys.MerchandisingDynamicPanelConfigs,
    HomeConfigurations
  >(FEATURE_NAME, HomeConfigurationKeys.MerchandisingDynamicPanelConfigs, '{}'),
  (merchandisingDynamicPanelConfigsStr) => {
    let merchandisingDynamicPanelConfigs: {
      [key: string]:
        | DynamicItemsConfigWithArguments
        | DynamicItemsConfigEntry[];
    };

    if (merchandisingDynamicPanelConfigsStr) {
      merchandisingDynamicPanelConfigs = JSON.parse(
        merchandisingDynamicPanelConfigsStr as string,
      );
    } else {
      merchandisingDynamicPanelConfigs = {};
    }
    return merchandisingDynamicPanelConfigs;
  },
);
